import { PropsWithChildren } from "react";
import { SimulatorChannel } from "@/api/simulator/simulator.model";
import { useSimulator } from "../../context/SimulatorWrapper";
import { useChat } from "../../context/ChatWrapper";
import { StartChatWithContext } from "./StartChatWithContext";
import styles from "./ChatInput.module.scss";

interface ChatInputWrapperProps {
  channel?: SimulatorChannel;
  messagesLength: number;
}

export function ChatInputWrapper({
  channel,
  messagesLength,
  children,
}: PropsWithChildren<ChatInputWrapperProps>) {
  const { currentRelease } = useSimulator();
  const { selectedTopic } = useChat();

  if (
    channel != null &&
    ["autonomous_ticket_event", "autonomous_quackchat"].includes(channel) &&
    messagesLength === 0 &&
    selectedTopic != null &&
    currentRelease != null
  ) {
    return (
      <StartChatWithContext
        channel={channel}
        topicId={selectedTopic.id}
        releaseId={currentRelease.id}
      >
        {children}
      </StartChatWithContext>
    );
  }

  return (
    <div className={styles.inputContainerWrapper} data-channel={channel}>
      {children}
    </div>
  );
}
